// @flow

/* eslint-disable new-cap */

import { get } from 'lodash';

import {
  CLEAR_BOOKING_TRANSPORT,
  FETCH_BOOKING_TRANSPORT,
  FETCH_BOOKING_TRANSPORT_RESOLVED,
  FETCH_BOOKING_TRANSPORT_REJECTED,
} from 'Store/member-space/booking/booking.constants';

import createReducer from 'Store/utils/createReducer';

const initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null,
};

export default createReducer(initialState, {
  [FETCH_BOOKING_TRANSPORT](state) {
    return {
      ...state,
      isLoading: true,
    };
  },
  [FETCH_BOOKING_TRANSPORT_RESOLVED](state, action) {
    return {
      ...state,
      data: get(action, 'payload.userBooking.transports'),
      isLoaded: true,
      isLoading: false,
    };
  },
  [FETCH_BOOKING_TRANSPORT_REJECTED](state, action) {
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      isOnError: true,
      errorResponse: { errors: action.payload.errors },
    };
  },
  [CLEAR_BOOKING_TRANSPORT]() {
    return initialState;
  },
});
